import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { observer } from 'mobx-react-lite';

import { DefaultAppProps } from '../App';
import { MuteIcon } from '../layout/icons/Mute';
import { UnmuteIcon } from '../layout/icons/Unmute';

export const SoundButtons: React.FC<DefaultAppProps> = observer(
    (props) => {
        const { hasGeneral, mute, hasSphere } = props.app.musicManager.state;

        if (!hasGeneral && !hasSphere) {
            return null;
        }

        return (
            <IconButton
                onClick={() => props.app.musicManager.setMute(!mute)}
            >
                {mute ? <MuteIcon/> : <UnmuteIcon/>}
            </IconButton>
        );
    }
);

SoundButtons.displayName = 'SoundButtons';